<template>
<div>
  <div class="chart-title">Activity</div>
          <div class="chart-menu">
      <div v-bind:class="'submenu_useractivity'">
        <div class="underline"></div>
        <div class="menuitem" @click="ul(0)">
          <span class="menutext">Timeline</span>
        </div>
        <div class="menuitem" @click="ul(1)">
          <span class="menutext">Trading Diary</span>
        </div>
       

        <div class="menuitem mr-4">
          <modalsSettings type="useractivity" />
        </div>
      </div>
    </div>

          <UserTimeline />
  </div>
</template>



<script>
import { mapGetters } from "vuex";
import UserTimeline from "@/components/UserTimeline/";
export default {
  components: { UserTimeline },
  data() {
    return {
      selectedIndex: 0,
      indexmap: [1, 2],
      loading: false,
      items: [],
      tempName: this.$route.params.name
    };
  },

  mounted() {
    this.ul(this.selectedIndex);
  },
  computed: {
    ...mapGetters(["timezone", "username"])
  },
  methods: {
    ul(newSelection) {
      this.selectedIndex = newSelection;

      var menuitem = document.querySelectorAll(".submenu_useractivity .menuitem");
      var menutext = document.querySelectorAll(
        ".submenu_useractivity .menuitem .menutext"
      );

      for (var i = 0; i < menutext.length; i++) {
        menutext[i].style.color = null;
      }
      menutext[this.selectedIndex].style.color = "#FFFFFF";
      var width = menutext[this.selectedIndex].offsetWidth;
      var x = menuitem[this.selectedIndex].offsetLeft;
      var underlines = document.querySelectorAll(
        ".submenu_useractivity .underline"
      );
      underlines[0].style.width = width + "px";
      underlines[0].style.transform = "translate3d(" + x + "px,0,0)";
    }
  }
};
</script>

<style scoped>
.menuitem {
  font-weight: bold;
  font-size: 12px;
  color: #808f9c;
  display: inline-block;
  z-index: 10;
  text-align: left;
  cursor: pointer;
  margin-right: 20px;
}
</style>